import React, { useEffect, useRef, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ToastConfirm } from '../common/toast';
import tenantStorage from '../../utils/tenantStorage';
import './UserProfileMenu.css';

function formatRoleLabel(roleCode) {
  const code = (roleCode || '').trim();
  if (!code) return '';
  return code.replace(/^RT_/, '').replace(/_/g, ' ');
}

const UserProfileMenu = () => {
  const [open, setOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();
  const rootRef = useRef(null);

  const username = tenantStorage.getItem('username') || '';
  const displayName =
    tenantStorage.getItem('staffName')
    || tenantStorage.getItem('userName')
    || username
    || 'User';
  const roleLabel = formatRoleLabel(tenantStorage.getItem('userRole'));

  useEffect(() => {
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const handleLogoutConfirm = () => {
    setShowLogoutConfirm(false);
    setOpen(false);
    tenantStorage.clear();
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('renttick-auth-updated'));
    }
    navigate('/login', { state: { mode: 'SESSION_LOGGED_OUT' } });
  };

  return (
    <>
      <div className="user-profile-menu" ref={rootRef}>
        <button
          type="button"
          className="user-profile-trigger"
          aria-label="Profile"
          aria-expanded={open}
          data-tooltip="Profile"
          onClick={() => setOpen((v) => !v)}
        >
          <FaUser />
        </button>
        {open ? (
          <div className="user-profile-dropdown" role="menu">
            <div className="user-profile-header">
              <div className="user-profile-name" title={displayName}>
                {displayName}
              </div>
              {roleLabel ? (
                <div className="user-profile-role" title={roleLabel}>
                  {roleLabel}
                </div>
              ) : null}
            </div>
            <div className="user-profile-divider" />
            <button
              type="button"
              className="user-profile-item"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                navigate('/profile/change-password');
              }}
            >
              Change Password
            </button>
            <button
              type="button"
              className="user-profile-item"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                navigate('/profile/change-username');
              }}
            >
              Change Username
            </button>
            <button
              type="button"
              className="user-profile-item user-profile-item-danger"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                setShowLogoutConfirm(true);
              }}
            >
              Logout
            </button>
          </div>
        ) : null}
      </div>
      <ToastConfirm
        show={showLogoutConfirm}
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        onConfirm={handleLogoutConfirm}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </>
  );
};

export default UserProfileMenu;
